import { AccountMatchingSettingsForm } from './types';
import {
    AccountMatchingState,
    AccountMatchingStateValues,
    UpdateAccountMatchingAction,
    UserManagementReducerState
} from './reducer/types';
import { DefaultValues } from 'react-hook-form';

const getInitialAdFieldsFormValues = ({
    adFieldsConfig,
    isCaseSensitive
}: AccountMatchingState): Partial<AccountMatchingSettingsForm['adFieldsConfig']> => {
    if (!adFieldsConfig.value) {
        return {
            isCaseSensitive: true
        };
    }

    return {
        isCaseSensitive: isCaseSensitive.value ?? true,
        matchAttribute: adFieldsConfig.value.matchAttribute,
        primaryUserIdentifyAttribute: adFieldsConfig.value.primaryUserIdentifyAttribute,
        primaryUserIdentifyValue: adFieldsConfig.value.primaryUserIdentifyValue
    };
};

export const getInitialFormValues = (
    reducerState: UserManagementReducerState
): DefaultValues<AccountMatchingSettingsForm> => {
    const { accountMatching, isTokenSharingEnabled } = reducerState.accountMatching.fields;

    return {
        isAccountMatchingEnabled: accountMatching.value.isAccountMatchingEnabled,
        isTokenSharingEnabled: isTokenSharingEnabled.value,
        shouldOverrideManualMatches: accountMatching.value.shouldOverrideManualMatches,
        adFieldsConfig: getInitialAdFieldsFormValues(reducerState.accountMatching.fields)
    };
};

const getAccountMatchingStateFieldValue = (
    formValues: AccountMatchingSettingsForm
): AccountMatchingStateValues['accountMatching'] => {
    if (!formValues.isAccountMatchingEnabled) {
        return {
            isAccountMatchingEnabled: false
        };
    }

    return {
        isAccountMatchingEnabled: formValues.isAccountMatchingEnabled,
        shouldOverrideManualMatches: formValues.shouldOverrideManualMatches
    };
};

const getAdFieldsConfigStateFieldValue = (
    formValues: AccountMatchingSettingsForm
): AccountMatchingStateValues['adFieldsConfig'] => {
    if (!formValues.isAccountMatchingEnabled || !formValues.adFieldsConfig) {
        return undefined;
    }

    return {
        matchAttribute: formValues.adFieldsConfig.matchAttribute,
        primaryUserIdentifyValue: formValues.adFieldsConfig.primaryUserIdentifyValue,
        primaryUserIdentifyAttribute: formValues.adFieldsConfig.primaryUserIdentifyAttribute
    };
};

export const getUpdateAccountMatchingPayload = (
    formValues: AccountMatchingSettingsForm
): UpdateAccountMatchingAction['payload'] => {
    return {
        accountMatching: getAccountMatchingStateFieldValue(formValues),
        adFieldsConfig: getAdFieldsConfigStateFieldValue(formValues),
        isCaseSensitive: formValues.adFieldsConfig?.isCaseSensitive,
        isTokenSharingEnabled: formValues.isAccountMatchingEnabled ? formValues.isTokenSharingEnabled : false
    };
};
